<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
        viewBox="0 0 48 48"
        version="1.1"
        :class="customClasses"
    >
        <defs></defs>
        <g id="Skisser" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
            <g id="Mina-Sidor-Hyressökande-Notifiering" sketch:type="MSArtboardGroup" transform="translate(-447.000000, -844.000000)" :fill="hexColor">
                <path d="M486.930013,863.827321 L486.930013,890.015786 L478.027284,890.015786 L478.027284,880.041564 C478.027284,880.041564 478.027284,871.694282 471.000001,871.694283 C463.972718,871.694284 464.014344,880.041564 464.014344,880.041564 L464.014344,890.015786 L455.071846,890.015786 L455.071846,863.827321 L452.988313,863.827321 L452.988313,891.965343 L466.056325,891.965343 L466.056326,880.041564 C466.056326,880.041564 465.918175,873.954229 471,873.954228 C476.081825,873.954228 476.081825,880.041564 476.081825,880.041564 L476.081824,891.965343 L489.067955,891.965343 L489.067956,863.827321 L486.930013,863.827321 Z M495,864.110926 L471,844 L447.072006,864.110926 L447.072006,866.589302 L471,846.889963 L495,866.589302 L495,864.110926 Z M482,844.289994 L481.004971,844.289994 L481.004971,846.265381 L482,846.265381 L482,850.926514 L486,854.342736 L486,846.265381 L487.065344,846.265381 L487.065344,844.289994 L486,844.289994 L482,844.289994 Z" id="home_L" sketch:type="MSShapeGroup"></path>
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            size: {
                type: String,
                required: false,
                default: 'small'
            },
            hexColor: {
                type: String,
                required: false,
                default: '#000000'
            }
        },
        setup(props) {
            const customClasses = ref({
                'icon': true,
                'icon--small': props.size === 'small',
                'icon--medium': props.size === 'medium',
                'icon--large': props.size === 'large'
            })

            return {
                customClasses
            }
        }
    })
</script>
